export default __webpack_public_path__ + "images/c3371751241af3af3c3bbfad4c47c5ad.svg";